/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2019 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/

import UIHandlerBase from "bundle/service/UIHandler";
import ServiceRegistry from "bundle/util/ServiceRegistry";
import LegalDialogUtil from "app/util/LegalDialogUtil";

export default class UIHandler extends UIHandlerBase {
    updateLegalDialogInHUD() {
        const appStore = ServiceRegistry.getService("AppStore");
        const previewRef = appStore.previewRef;
        if (previewRef && appStore.configStore.getConfig().showLegalNotice) {
            previewRef.getPublicApis().then(api => {
                if (appStore.configStore.showFullScreen && !appStore.inFullScreen) {
                    const showLegalDialog = () => {
                        ServiceRegistry.getService("DialogApi").showLegalDialog();
                    };
                    appStore.legalDialogIdInHUD = api.hud.addUIControl(
                        LegalDialogUtil.getLegalDialogData(showLegalDialog),
                    );
                }
            });
        }
    }
}
